import { BaseEnvironment } from '@mkp/shared/models';
import { getIsDebugActive } from './debug.helper';

export const getDefaultFeatureFlags = (environment?: BaseEnvironment) => ({
  default: environment ? getIsDebugActive(environment) : false,
  missingTranslations: environment ? getIsDebugActive(environment) : false,
  keepMenusOpen: false,
  routerTracingEnabled: false,
  shouldTriggerSilentUpdate: false,
  trackingLink: false,
  trackingView: false,
  trackingClick: false,
});

export const getCoreDomainFeatureFlags = () => ({
  isInvoiceEnabled: false,
  isGenerateAbandonedLinkEnabled: false,
  isNewAccountManagementEnabled: false,
  isPayPerInviteEnabled: false,
});

export const getSeeFeatureFlags = () => ({
  isNewPreviewUI: false,
  isNewSalaryDesign: false,
  isPublicationPPPFeatureEnabled: false,
  isMultipleWorkLocationsEnabled: true,
  isVBPEnabled: false, // Master flag for VBP (Value Based Pricing / "Performance") features (SEE-452)
  isVBPMockProductsEnabled: false,
  isTeachableWidgetEnabled: false,
  isSocialProfilesEnabled: true, // Social profiles on the company profile (SEE-463)
});

export const getFeatureFlagsInitialState = (environment?: BaseEnvironment) =>
  ({
    ...getDefaultFeatureFlags(environment),
    ...getCoreDomainFeatureFlags(),
    ...getSeeFeatureFlags(),
  }) as const;

/**
 * Derived from the registry rather than declared alongside it, so a flag joins the
 * union by being added to one of the domain groups above and nothing else.
 */
export type FeatureFlags = ReturnType<typeof getFeatureFlagsInitialState>;
export type FeatureFlag = keyof FeatureFlags;
